var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNumberTwo = function SvgIconNumberTwo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.696 4.072a3.5 3.5 0 0 0-3.919 2.065 1 1 0 0 1-1.842-.78A5.5 5.5 0 0 1 17.5 7.498a5.44 5.44 0 0 1-.968 3.114L9.499 20H16.5a1 1 0 0 1 0 2h-9a1 1 0 0 1-.8-1.6l8.216-10.967c.383-.57.586-1.243.584-1.93V7.5a3.5 3.5 0 0 0-2.804-3.428M17.5 7.498V7.5h-1l1-.003z",
    clipRule: "evenodd"
  })));
};
export default SvgIconNumberTwo;